module.exports = __webpack_public_path__ + "img/1.25f5925e.png";